/**
 * Reports whether the Silent Witness UI is enabled for the current build.
 * Derived from sw_api_key presence in the deploy target; defaults off.
 * @returns {boolean}
 */
const useSilentWitnessFeatureFlag = () =>
  import.meta.env.VITE_ENABLE_SILENT_WITNESS_UI === 'true';

export default useSilentWitnessFeatureFlag;
